import {HoverCard} from "@project/design-system-web";

export interface OverflowTextProps {
  /** Text to display (and preview in full on hover). */
  text?: string | null;
  /** Value rendered when text is empty/null. */
  emptyValue?: string;
  /** Extra classes applied to the truncated text element. */
  className?: string;
}

/**
 * OverflowText — single-line truncated table cell text with a HoverCard preview.
 *
 * Renders the text as a truncated `span` (the HoverCard.Trigger itself, so the
 * trigger spans the full cell width and truncates correctly). Hovering shows
 * the full content in a card.
 */
export function OverflowText({text, emptyValue = "—", className}: OverflowTextProps) {
  if (!text) return <span className={className}>{emptyValue}</span>;

  return (
    <HoverCard closeDelay={150} openDelay={300}>
      <HoverCard.Trigger
        className={`block truncate overflow-hidden whitespace-nowrap ${className ?? ""}`}
      >
        {text}
      </HoverCard.Trigger>
      <HoverCard.Content className="max-w-md" placement="top">
        <HoverCard.Arrow />
        <p className="text-sm break-words whitespace-pre-wrap">{text}</p>
      </HoverCard.Content>
    </HoverCard>
  );
}
